// extracted by mini-css-extract-plugin
export default {"case_main_title":"CaseMainTitle_case_main_title__zQu36"};